import axios from 'axios'

const instance = axios.create({
  // Vue CLI only exposes vars prefixed with VUE_APP_ to the client bundle, so
  // process.env.API_ENDPOINT was always undefined and this instance had no base.
  baseURL: process.env.VUE_APP_API_ENDPOINT
})

// instance.defaults.headers.common['SOMETHING'] = 'something'

export default instance